export const ROUTEPATHS = {
  HOME: "/",
  ABOUT: "/about",
  PRICING: "/pricing",
  ROADMAP: "/roadmap",
  BLOCKCHAIN: "/blockchain",
  CONFIRM_USER: "/confirm_user",
  TEAM: "/team",
  CONTACT: "/contact",
  LOGIN: "/login",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  VOD: "/vod-uploads",
  LIVE_CHANNELS: "/live-channels",
  AD_SERVER: "/ad-server",
  SUPPORT_TICKETING: "/support-ticketing",
  RECORDINGS: "/recordings",
  MANAGE_PAYMENTS_ROUTE: "/manage-payments",
  MY_PLAN: "/my-plan",
  MANAGE_PAYMENTS_PLANS: "/payment-plans",
  MANAGE_ACCESS_TOKENS: "/manage-access-tokens",
  MANAGE_REFERRALS: "/referral-programs",
  MANAGE_COUPONS: "/coupon-codes",

  MANAGE_STORAGE: "/manage-storage",
  MANAGE_LIBRARIES: "/manage-libraries",

  MANAGE_CONTROLS: "/manage-controls",
  MANAGE_TEMPLATE: "/manage-templates",
  MANAGE_TEMPLATE_PLAYLIST_DETAIL: "manage-templates/playlists/:playlistId",
  MANAGE_TEMPLATE_VOD: "manage-templates/vod",
  MANAGE_TEMPLATE_PLAYLISTS: "manage-templates/playlists",
  MANAGE_TEMPLATE_LIVE_STREAMS: "manage-templates/live-streams",

  LIBRARY_OUTLETS: "/library-outlets",
  EMBED_CODE: "/embed-code",

  MANAGE_PROFILES: "/manage-profiles",
  MANAGE_PROFILE_VERSIONS: "manage-profiles/:profileId/versions",
  MANAGE_VERSION_BLOCKS: "manage-profiles/:profileId/versions/:versionId/blocks",

  ADMIN: "/admin",
  MANAGE_USERS: "/manage-users",
  MANAGE_PACKAGES: "/manage-packages",
  MANAGE_PUBLIC_PLANS: "/manage-public-plans",
  CONTACT_INQUIRIES: "/contact-inquiries",
  PLAYLISTS: "/playlists",
  FILES: "/files",
  FILE_SHARE: "/files/share/:shareToken",
};

export const isComingSoon = false;

export const API_BASE_PATHS = {
  USERS_API: "v1/user",
  VOD_API: "v1/vod",
  SUPPORT_API: "v1/support-service",
  STREAM_API: "v1/live-stream",
  CLIENT_API: "v1/client",
  PAYMENTS_API: "v1/payments",
  AD_SERVER_API: "v1/ad-server",
  ADMIN_API: "v1/admin",
  PLAYLISTS_API: "v1/playlist-service",
  ANALYTICS_API: "v1/analytics",
  BLOCKS_API: "v1/blocks-service",
  EMBED_API: "v1/e",
};

export const API_ROUTES = {
  // Users service API Paths
  GET_CURRENT_USER: "me",
  GET_USER_BY_EMAIL: "search",
  GET_LIBRARY_CONFIG: "library-config",
  GET_TEMPLATE_ORDER: "update-template-order",
  REGISTER_USER: "register",
  CREATE_SUBSCRIPTION: "create-subscription",
  COMPLETE_SUBSCRIPTION: "complete-subscription",
  SUBSCRIPTION: "subscription",
  PREVIEW_SUBSCRIPTION_UPGRADE: "subscription/upgrade-preview",
  UPGRADE_SUBSCRIPTION: "subscription/upgrade",
  CREATE_PAYMENT_METHOD_SETUP: "subscription/payment-method/setup",
  COMPLETE_PAYMENT_METHOD_UPDATE: "subscription/payment-method",
  CANCEL_SUBSCRIPTION: "subscription/cancel",
  REACTIVATE_SUBSCRIPTION: "subscription/reactivate",
  GET_PROMO_CODE_ID: "promocode",
  KV_STORE: "kv-store",

  // VOD API Paths
  MEDIA: "list",
  INITIALIZE_MULTIPART_UPLOAD: "initialize-multipart-upload",
  GET_MULTIPART_PRESIGNED_URLS: "create-multipart-presigned-urls",
  FINALIZE_MULTIPART_UPLOAD: "finalize-multipart-upload",
  MOVE_TO_VOD: "movetovod",
  CATEGORY: "category",

  // Live Channels paths
  CHANNELS: "channels",
  CHANNEL: "channel",
  GET_EVENTS: "upcoming-events",

  // Payment service paths
  CREATE_ACCOUNT: "create-account",
  SAVE_ACCOUNT: "save-account",
  GET_ACCOUNT_DETAILS: "get-account-details",
  MEMBER_PLANS: "member-plans",
  UPDATE_ACCOUNT: "update-account",
  GET_UPDATE_ACCOUNT_LINK: "update-account-link",
  FREE_TRIAL_ACCESS_TOKEN: "freeTrial",
  GET_FREE_TRIAL_ACCESS_TOKENS: "all-trial-code",
  GET_FREE_TRIAL_USERS: "all-trialuser-code",
  REFERRAL_PROGRAMS: "referral-programs",
  COUPONS: "coupons",

  // Ad Server paths
  STATIC_AD: "staticAd",

  //Support ticket paths
  STATIC_TICKET: "tickets",
  GET_PRIORITIES: "priorities",
  GET_STATUSES: "statuses",
  GET_TYPES: "types",
  GET_REPLIES: "replies",
  ADD_REPLY: "reply",

  //Campaign
  AD_CAMPAIGN: "ad-campaigns",
  // Admin Paths
  USERS: "users",
  GENERATE_PAYMENT_LINK: "users/sendemail",
  PACKAGES: "packages",
  PUBLIC_PLANS: "public-plans",
  CONTACT_INQUIRIES: "contact-inquiries",
  UPDATE_MANUAL_PAYMENT: "payment/users",
  SWITCH_MANUAL_BILLING_TO_STRIPE: "payment/users",

  // Playlist service paths
  PLAYLIST: "playList",

  // Analytics paths
  METRICES: "videometrics",
  METRICES_SUMMARY: "videometrics/summary",
  METRICES_FRESH: "videometrics/fresh-unique-views",

  // Blocks service paths
  // Outlets
  LIBRARY_OUTLETS: "library-outlets",
  // Profiles
  PROFILES: "profiles",
  PROFILE: "profiles",
  // Versions
  VERSIONS: "versions",
  VERSION: "version",
  ACTIVATE_VERSION: "activate",
  // Blocks
  BLOCKS: "blocks",
  BLOCK: "block",
  // embed
  EMBED_SLUG_CHECK: "slug/check",
  EMBED_SLUG: "slug",
};
